import EnhancedLocation from 'owa-service/lib/contract/EnhancedLocation';
import { IWorkDay } from 'owa-scheduling-hours';
import { OwaDate } from 'owa-datetime';

export interface ServiceEditOptionState {
    id: string;
    name: string;
    description: string;
    charm: number;
    categoryNames: Array<string>;
    duration: number;
    location: EnhancedLocation;
    isOnlineMeeting: boolean;
    schedulingPolicy: SchedulingPolicyState;
    availability: AvailabilityState;
    hasError: boolean;
    showErrorMessage: boolean;
}

export interface SchedulingPolicyState {
    leadTimeInMinutes: number;
    endOfBookingWindowInDays: number;
}

export interface AvailabilityState {
    availabilityType?: AvailabilityType;
    isDateRestricted?: boolean;
    startDate?: OwaDate;
    endDate?: OwaDate;
    customHours?: IWorkDay[];
    isDirty?: boolean;
}

export enum AvailabilityType {
    Undefined = 0,
    DefaultSetup = 1,
    NotBookable = 2,
    Custom = 3,
}

export default ServiceEditOptionState;
